import { type FC, type ReactElement, type ReactNode } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Link, Notification } from 'base-ui'

import {
  CONTACT_FORM_SUBJECT_KEY,
  directContactFormSubjectCatalogGetValue,
} from '../model/directContactFormSubjectCatalog'

export const DirectContactFormCopaymentExemptionNotification: FC<{
  isLoggedIn: boolean
}> = ({ isLoggedIn }) => {
  const intl = useIntl()
  const emailAddress = intl.formatMessage({
    id: 'contactForm.label.email.invitation.email',
  })
  const emailSubject = directContactFormSubjectCatalogGetValue(
    intl,
    CONTACT_FORM_SUBJECT_KEY.COPAYMENT_EXEMPTION,
  )
  const link = (text: ReactNode[]): ReactElement => (
    <Link
      className="font-medium text-dark-primary-max"
      href={`mailto:${emailAddress}?subject=${emailSubject}`}
    >
      {text}
    </Link>
  )

  return (
    <Notification
      className="mt-3 space-y-2"
      data-qa-id="contact-copayment-exemption-notification"
      icon
      severity="info"
      title={intl.formatMessage({
        id: 'erxFamily.benefits.security.title',
      })}
    >
      <p>
        {isLoggedIn ? (
          <FormattedMessage id="direct.contact.form.copayment.exemption.notification.loggedIn" />
        ) : (
          <FormattedMessage
            id="direct.contact.form.copayment.exemption.notification.loggedOut"
            values={{ link }}
          />
        )}
      </p>
      <p className="mt-4">
        <FormattedMessage id="direct.contact.form.copayment.exemption.notification.info" />
      </p>
    </Notification>
  )
}
